import { CarModelMain } from "api"
import VideoModelFullScreen from "components/carModelPage/reusable/VideoModelFullScreen"
import { useRouter } from "next/dist/client/router"
import styled from "styled-components"
import ModelTextSection from "../../reusable/ModelTextSection"
import ModelComparisonSlider from "./comparisonSlider/ModelComparisonSlider"
import EntrenchComponent from "./enterence/EntrenchComponent"

const StyledWrap = styled.div`
  width: 100%;
  height: max-content;
  background-color: ${(p) => p.theme.colors.lightGrey};
`

type ExteriorSectionProps = {
  data: CarModelMain
  setCalculatorPopupOpen?: (falsy: boolean) => void
}

const ExteriorSection = ({
  data,
  setCalculatorPopupOpen,
}: ExteriorSectionProps) => {
  const router = useRouter()
  const openCalculator = () => {
    router
      .replace(
        {
          pathname: router.asPath.split("?")[0],
          query: {
            engineId: data?.finishingLevels?.engines?.[0]?.engineId,
          },
        },
        null,
        {
          shallow: true,
        }
      )
      .then(() => setCalculatorPopupOpen(true))
  }

  return (
    <StyledWrap>
      <EntrenchComponent
        outsideData={data?.outside}
        generalInfo={data?.generalInfo}
        openCalculator={openCalculator}
      />
      {data?.outside?.video && (
        <VideoModelFullScreen
          src={data?.outside?.video?.desktopImageUrl}
          imgDesktop={data?.outside?.video?.desktopImageUrl}
          imgMobile={data?.outside?.video?.mobileImageUrl}
          alt={data?.outside?.video?.alt}
        />
      )}
      {data?.outside?.outsideDesignText && (
        <ModelTextSection text={data?.outside?.outsideDesignText} />
      )}
      {data?.outside?.frontCurtain && data?.outside?.backCurtain && (
        <ModelComparisonSlider data={data?.outside} />
      )}
    </StyledWrap>
  )
}

export default ExteriorSection
